import React from 'react';
import { StarIcon, LockIcon, TrophyIcon, ShieldCheckIcon, CheckIcon, ZapIcon } from 'lucide-react';
import { heroImage, heroStats } from '../data/content';
import { CtaButton } from './ui/CtaButton';
export function Hero() {
  return <header className="grid-bg relative w-full overflow-hidden bg-night px-5 pb-10 pt-4 md:pt-8" data-id="element-65" data-mp="9lbg511q9bdl">
      <div className="mx-auto flex max-w-3xl flex-col items-center text-center" data-id="element-66" data-mp="4na0yr7f9w7e">
        <div className="flex gap-1 text-gold" aria-hidden="true" data-id="element-67" data-mp="128frrovbsnyc">
          {Array.from({
          length: 5
        }).map((_, index) => <StarIcon key={index} className="h-4 w-4 fill-gold" data-id="element-68" data-mp="xb5rtfab8tw9" data-mpi={index} />)}
        </div>

        <p className="mt-4 rounded-full border border-gold/40 bg-gold/10 px-5 py-2 font-display text-[11px] font-semibold uppercase tracking-[0.2em] text-gold" data-id="element-69" data-mp="s9q7xqjvctfg">
          Muy valorado por lectores de la Biblia
        </p>

        <p className="mt-6 text-sm text-cream-dim md:text-base" data-id="element-70" data-mp="3cz5u28857tyr">
          Ideal para grupos de estudio bíblico, maestros de escuela dominical, pastores y lectores devotos
        </p>

        <h1 className="mt-4 font-display text-3xl font-bold leading-tight text-cream md:text-5xl" data-id="element-71" data-mp="3j9afx9oryk3k">
          Deja de leer la Biblia sin{' '}
          <span className="text-gold" data-id="element-72" data-mp="39auqdb5ebiw6">ver dónde ocurrió todo</span>
        </h1>

        <p className="mt-6 max-w-xl text-base leading-relaxed text-cream-dim md:text-lg" data-id="element-73" data-mp="3e9frdcsh26lo">
          Convierte nombres confusos, lugares desconocidos y recorridos bíblicos complejos en una comprensión visual
          clara de las Escrituras con{' '}
          <strong className="font-semibold text-gold" data-id="element-74" data-mp="359javyg8ke1p">reconstrucciones 3D, mapas detallados e imágenes en alta
          resolución</strong>{' '}
          — de Génesis a Apocalipsis.
        </p>

        <figure className="relative mt-10 w-full overflow-hidden rounded-xl border border-gold/50 bg-night-card" data-id="element-75" data-mp="2vjzmkd9r7rzg">
          <img src={heroImage} alt="Guía Geografía Bíblica 3D — de Génesis a Apocalipsis" className="w-full" loading="eager" data-id="element-76" data-mp="2hjowvdk6kjfv" />
          <figcaption className="absolute right-4 top-4 rounded-md bg-gold px-3 py-1 font-display text-xs font-bold uppercase tracking-wide text-night-deep" data-id="element-77" data-mp="s2tenov66frb">
            300+ páginas
          </figcaption>
        </figure>

        <dl className="mt-8 grid w-full grid-cols-3 divide-x divide-night-line rounded-lg border border-night-line bg-night-soft" data-id="element-78" data-mp="ichwoyeni61f">
          {heroStats.map(stat => <div key={stat.label} className="px-3 py-5" data-id="element-79" data-mp="1azullf8aapxw">
              <dt className="sr-only" data-id="element-80" data-mp="161t0korasgjs">{stat.label}</dt>
              <dd data-id="element-81" data-mp="162cabi6snymq">
                <span className="block font-display text-2xl font-bold text-gold md:text-3xl" data-id="element-82" data-mp="15zq2dhfzrh3z">{stat.value}</span>
                <span className="mt-1 block text-xs text-cream-dim md:text-sm" data-id="element-83" data-mp="114kjyslsskkn">{stat.label}</span>
              </dd>
            </div>)}
        </dl>

        <div className="mt-12" data-id="element-84" data-mp="3ltqclcptivti">
          <p className="font-display text-[11px] font-semibold uppercase tracking-[0.25em] text-cream" data-id="element-85" data-mp="3lqm1dvdxqztc">
            100% basada en la
          </p>
          <p className="mt-3 font-display text-2xl font-bold uppercase tracking-wide text-gold md:text-3xl" data-id="element-86" data-mp="1xa44lgt9woko">
            Santa Biblia
          </p>
          <p className="mt-3 text-sm text-cream-dim" data-id="element-87" data-mp="218tl3i9lym8j">
            Compatible con Reina-Valera, NVI, LBLA, DHH y todas las traducciones principales
          </p>
        </div>

        <ul className="mt-6 flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-xs text-cream-dim md:text-sm" data-id="element-88" data-mp="2b2aggqpe89eb">
          <li className="flex items-center gap-2" data-id="element-89" data-mp="2g1wyrek2wftz">
            <LockIcon className="h-4 w-4 text-gold" aria-hidden="true" data-id="element-90" data-mp="2kxucre7vda3l" /> Pago seguro
          </li>
          <li className="flex items-center gap-2" data-id="element-91" data-mp="2p1jxfslfb7jc">
            <TrophyIcon className="h-4 w-4 text-gold" aria-hidden="true" data-id="element-92" data-mp="2oyo128p84qx0" /> Satisfacción garantizada
          </li>
          <li className="flex items-center gap-2" data-id="element-93" data-mp="umppw17ctkyh">
            <ShieldCheckIcon className="h-4 w-4 text-gold" aria-hidden="true" data-id="element-94" data-mp="uo0svysz6ooj" /> Privacidad protegida
          </li>
        </ul>

        <p className="mt-8 flex w-full items-center justify-center gap-2 rounded-lg border border-night-line bg-night-soft px-5 py-4 text-sm text-cream" data-id="element-95" data-mp="zndqneldxg5w">
          <CheckIcon className="h-4 w-4 text-emerald-400" aria-hidden="true" data-id="element-96" data-mp="3vgnjoymw87u0" />
          Más de 1.330 visitas en las últimas 24 horas
        </p>

        <ul className="mt-6 flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-xs text-cream-dim" data-id="element-97" data-mp="e77ibopw7dij">
          <li className="flex items-center gap-2" data-id="element-98" data-mp="3hqabqwa04t4o">
            <LockIcon className="h-3.5 w-3.5 text-gold" aria-hidden="true" data-id="element-99" data-mp="3hqsdg8ffnzjz" /> Pago seguro
          </li>
          <li className="flex items-center gap-2" data-id="element-100" data-mp="3csqwpu5hccbo">
            <ZapIcon className="h-3.5 w-3.5 text-gold" aria-hidden="true" data-id="element-101" data-mp="3rftw66dd4v1n" /> Entrega inmediata en PDF
          </li>
          <li data-id="element-102" data-mp="3mp3m4ftzs40m">Con la confianza de más de 4.000 lectores</li>
        </ul>

        <CtaButton className="mt-8" data-id="element-103" data-mp="2yzsrzh75d7vg">Quiero acceder a los mapas 3D</CtaButton>
      </div>
    </header>;
}